import { chakra, forwardRef, Box as Box$1, Stack as Stack$1, useStyleConfig, VisuallyHidden, toCSSVar, CSSVars, useToast, useMergeRefs, useSafeLayoutEffect, extendTheme, ChakraProvider, Heading as Heading$1, useInterval, VStack, HStack, Center } from '@chakra-ui/react';
import { keyframes, css, Global, useTheme as useTheme$1, ThemeProvider } from '@emotion/react';
import { motion as motion$2 } from '@hover/chakra-theme/foundation';
import { includes, entries, pick, random } from '@hover/utilities';
import { motion as motion$1, AnimatePresence } from 'framer-motion';
import { useMemo, useId, cloneElement, Children, useEffect, useRef, useContext as useContext$1, Fragment, createContext as createContext$1, useState } from 'react';
import 'ramda/src/has';
import warning from 'tiny-warning';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import 'ramda/src/omit';
import 'ramda/src/mapObjIndexed';
import 'ramda/src/join';
import 'ramda/src/identity';
import 'ramda/src/ifElse';
import 'ramda/src/map';
import 'ramda/src/split';
import 'ramda/src/concat';
import 'ramda/src/toLower';
import 'ramda/src/pipe';
import { theme as theme$2 } from '@hover/chakra-theme/bauhaus';
import { theme } from '@hover/chakra-theme/next';
import invariant from 'tiny-invariant';
import { mapResponsive, theme as theme$1, reduceResponsive } from '@hover/chakra-theme';
import { createContext } from '@chakra-ui/react-utils';
import { fontAdelleSans, fontMonoLisa } from '@hover/tokens-typography';
import { fontDiatype } from '@hover/tokens-typography/next';
import _mergeDeepLeft from 'ramda/src/mergeDeepLeft';
import _mergeLeft from 'ramda/src/mergeLeft';
import { headingAliases } from '@hover/chakra-theme/components';

function toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}

function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

var svgElements = ['animate', 'circle', 'clipPath', 'defs', 'desc', 'ellipse', 'feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feDropShadow', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence', 'filter', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'marker', 'mask', 'metadata', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'symbol', 'text', 'textPath', 'tspan', 'use'];
/**
 * Framer Motion's `motion` factory with types that work properly with system
 * components and returns motion components augmented with system style props
 * when using the shortand for intrinsic HTML elements (e.g: `<motion.div />`)
 *
 * Note that there a couple things to keep in mind when working with motion
 * components:
 *
 * - If you're going to spread external props into the component, make sure to
 *   type the props using `MotionPropsFor` (see example below).
 * - If the root component in your custom component is a `motion()` component,
 *   you must always forward a ref to it with `forwardRef` as Framer uses refs
 *   for some types of motion.
 *
 * @example
 * ```tsx
 * import { forwardRef, motion, MotionPropsFor, Box, BoxProps } from '@hover/blueprint';
 *
 * export interface MyAnimatedComponentProps extends MotionPropsFor<BoxProps> {
 *   isFoo?: boolean;
 * }
 *
 * const MotionBox = motion(Box);
 *
 * export const MyAnimatedComponent = forwardRef<MyAnimatedComponentProps, 'div'>(
 *   ({ isFoo, ...props }) => <MotionBox {...props}>{isFoo ? 'foo' : 'bar'} />
 * )
 * ```
 */
var motion = /*#__PURE__*/function () {
  // I don't think it's really possible to type this stuff properly with Framer
  // Motion types and trying to do so brought TypeScript to its knees for some
  // reason. Even if it didn't I'm not sure it's worth it.
  var cache = /*#__PURE__*/new Map();
  return new Proxy(motion$1, {
    get: function get(_, element) {
      if (includes(svgElements, element)) {
        return motion$1[element];
      }
      if (!cache.has(element)) cache.set(element, motion$1(chakra(element)));

      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return cache.get(element);
    }
  });
}();

var _excluded2 = ["testId"];
var attribute = 'data-testid';
var dataAttribute = function dataAttribute(condition) {
  return condition ? '' : undefined;
};

/**
 * Returns an object containing test ID *attribute* (e.g: `data-testid`)
 *
 * @example
 * const props = { testId: 'foo', bar: 'baz' };
 * <Component {...applyTestId(props)} />
 * // Equivalent
 * <Component data-testid="foo" />
 *
 * @param props - Props object with test ID prop
 *
 * @returns Object with test ID attribute
 */
var applyTestId = function applyTestId(_ref2) {
  var testId = _ref2.testId;
  return _defineProperty({}, attribute, testId);
};

/**
 * Replaces the test ID prop in supplied props object with a test ID *attribute* (e.g: `data-testid`)
 *
 * @example
 * const props = { testId: 'foo', bar: 'baz' };
 * <Component {...withTestId(props)} />
 * // Equivalent
 * <Component data-testid="foo" bar="baz" />
 *
 * @param props - Props object with test ID prop
 *
 * @returns Props object with test ID *attribute* in place of test ID prop
 */
var withTestId = function withTestId(_ref4) {
  var testId = _ref4.testId,
    props = _objectWithoutProperties(_ref4, _excluded2);
  return _objectSpread2(_objectSpread2({}, applyTestId({
    testId: testId
  })), props);
};

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _excluded$a = ["children"];
var Box = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$a);
  return jsx(Box$1, _objectSpread2(_objectSpread2({
    boxSizing: "border-box",
    display: "flex"
  }, withTestId(props)), {}, {
    ref: ref,
    children: children
  }));
});
Box.displayName = 'Box';

var _excluded$9 = ["children", "spacing"];
var selector = '& > *:not(style) ~ *:not(style)';
function getStackStyles(options) {
  var spacing = options.spacing,
    direction = options.direction;
  var directionStyles = {
    column: {
      marginTop: spacing,
      marginEnd: 0,
      marginBottom: 0,
      marginStart: 0
    },
    row: {
      marginTop: 0,
      marginEnd: 0,
      marginBottom: 0,
      marginStart: spacing
    },
    'column-reverse': {
      marginTop: 0,
      marginEnd: 0,
      marginBottom: spacing,
      marginStart: 0
    },
    'row-reverse': {
      marginTop: 0,
      marginEnd: spacing,
      marginBottom: 0,
      marginStart: 0
    }
  };
  return _defineProperty({}, selector, mapResponsive(function (value) {
    return directionStyles[value];
  }, direction));
}
var Stack = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var _props$direction;
  var children = _ref2.children,
    _ref2$spacing = _ref2.spacing,
    spacing = _ref2$spacing === void 0 ? '0.5rem' : _ref2$spacing,
    props = _objectWithoutProperties(_ref2, _excluded$9);
  var hasDivider = !!props.divider;
  var direction = (_props$direction = props.direction) !== null && _props$direction !== void 0 ? _props$direction : 'column';
  var styles = useMemo(function () {
    return getStackStyles({
      direction: direction,
      spacing: spacing
    });
  }, [direction, spacing]);
  return jsx(Stack$1
  // @ts-expect-error
  , _objectSpread2(_objectSpread2({
    __css: hasDivider ? {} : styles,
    ref: ref
    // We calculated the spacing above and passed to
    // __css prop, so we need to zero out the spacing
    // on the base Stack component.
    ,
    spacing: 0
  }, props), {}, {
    children: children
  }));
});
Stack.displayName = 'Stack';

var _excluded$8 = ["label", "color", "speed", "size"];
var _templateObject$1;
var durations = {
  500: motion$2.animation.spin[500].duration,
  700: motion$2.animation.spin[700].duration
};
var spin$1 = /*#__PURE__*/keyframes(_templateObject$1 || (_templateObject$1 = /*#__PURE__*/_taggedTemplateLiteral(["\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n"])));
var Loader$1 = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Loading' : _ref$label,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'primary.600' : _ref$color,
    _ref$speed = _ref.speed,
    speed = _ref$speed === void 0 ? 500 : _ref$speed,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'small' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded$8);
  var styles = useStyleConfig('Icon', _objectSpread2({
    size: size
  }, props));
  return jsxs(Box, _objectSpread2(_objectSpread2({}, withTestId(props)), {}, {
    alignContent: "center",
    "aria-busy": true,
    color: color,
    justifyContent: "center",
    ref: ref,
    children: [jsx(VisuallyHidden, {
      "aria-live": "polite",
      children: label
    }), jsxs(chakra.svg, {
      animation: "".concat(durations[speed], "s linear 0s infinite normal none running ").concat(spin$1),
      "aria-hidden": "true",
      focusable: "false",
      role: "img",
      sx: styles,
      viewBox: "0 0 512 512",
      xmlns: "http://www.w3.org/2000/svg",
      children: [jsx("path", {
        d: "M478.71 364.58zm-22 6.11l-27.83-15.9a15.92 15.92 0 0 1-6.94-19.2A184 184 0 1 1 256 72c5.89 0 11.71.29 17.46.83-.74-.07-1.48-.15-2.23-.21-8.49-.69-15.23-7.31-15.23-15.83v-32a16 16 0 0 1 15.34-16C266.24 8.46 261.18 8 256 8 119 8 8 119 8 256s111 248 248 248c98 0 182.42-56.95 222.71-139.42-4.13 7.86-14.23 10.55-22 6.11z",
        fill: "currentColor",
        opacity: 0.4
      }), jsx("path", {
        d: "M271.23 72.62c-8.49-.69-15.23-7.31-15.23-15.83V24.73c0-9.11 7.67-16.78 16.77-16.17C401.92 17.18 504 124.67 504 256a246 246 0 0 1-25 108.24c-4 8.17-14.37 11-22.26 6.45l-27.84-15.9c-7.41-4.23-9.83-13.35-6.2-21.07A182.53 182.53 0 0 0 440 256c0-96.49-74.27-175.63-168.77-183.38z",
        fill: "currentColor"
      })]
    })]
  }));
});

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

/**
 * Generate a unique name for a CSS selector that's SSR-safe using React's
 * `useId` hook. The problem with `useId` is that it includes colons in the
 * generated ID, which isn't supported for CSS selectors.
 *
 * @param prefix
 * @param separator
 *
 * @returns unique string that can be used as a CSS selector
 */
var useUniqueSelector = function useUniqueSelector(prefix) {
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '--';
  return "".concat(prefix).concat(useId().replace(':', separator).replace(':', ''));
};

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

var _excluded$7 = ["host"];
var ASSET_HOST = 'https://blueprint.hover.to/assets/typography/';
var fontStylesFactory = function fontStylesFactory(fn) {
  return function (_ref) {
    var host = _ref.host,
      rest = _objectWithoutProperties(_ref, _excluded$7);
    return (
      // @ts-ignore
      fn(_objectSpread2({
        host: host !== null && host !== void 0 ? host : ASSET_HOST
      }, rest))
    );
  };
};

/**
 * Outputs @font-face declarations for Adelle Sans font. Unlike the other font
 * styles factories, Adelle Sans has two variations: original and "shifted" on
 * account of the raised baseline Adelle has out of the box. The "shifted"
 * version will load alternative assets what have the baseline shifted down 100
 * units (in 1000 units-per-em space)
 *
 * @param host prefix for asset URL
 * @param isShifted whether to load "shifted" assets or not (defaults to true)
 */
var adelleSans = /*#__PURE__*/fontStylesFactory(function (_ref) {
  var host = _ref.host,
    _ref$isShifted = _ref.isShifted,
    isShifted = _ref$isShifted === void 0 ? true : _ref$isShifted;
  var suffix = isShifted ? '-hover' : '';
  return /*#__PURE__*/css("@font-face{font-family:", fontAdelleSans, ";src:url(", host, "adelle-sans", suffix, "--light.otf) format('opentype');font-weight:300;font-style:normal;font-display:fallback;}@font-face{font-family:", fontAdelleSans, ";src:url(", host, "adelle-sans", suffix, "--light-italic.otf) format('opentype');font-weight:300;font-style:italic;font-display:fallback;}@font-face{font-family:", fontAdelleSans, ";src:url(", host, "adelle-sans", suffix, "--regular.otf) format('opentype');font-weight:400;font-style:normal;font-display:fallback;}@font-face{font-family:", fontAdelleSans, ";src:url(", host, "adelle-sans", suffix, "--italic.otf) format('opentype');font-weight:400;font-style:italic;font-display:fallback;}@font-face{font-family:", fontAdelleSans, ";src:url(", host, "adelle-sans", suffix, "--semi-bold.otf) format('opentype');font-weight:600;font-style:normal;font-display:fallback;}@font-face{font-family:", fontAdelleSans, ";src:url(", host, "adelle-sans", suffix, "--semi-bold-italic.otf) format('opentype');font-weight:600;font-style:italic;font-display:fallback;}@font-face{font-family:", fontAdelleSans, ";src:url(", host, "adelle-sans", suffix, "--bold.otf) format('opentype');font-weight:700;font-style:normal;font-display:fallback;}@font-face{font-family:", fontAdelleSans, ";src:url(", host, "adelle-sans", suffix, "--bold-italic.otf) format('opentype');font-weight:700;font-style:italic;font-display:fallback;}" + (process.env.NODE_ENV === "production" ? "" : ";label:adelleSans;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
});

var diatype = /*#__PURE__*/fontStylesFactory(function (_ref) {
  var host = _ref.host;
  return /*#__PURE__*/css("@font-face{font-family:", fontDiatype, ";src:url(", host, "diatype-bold-italic.woff2) format('woff2'),url(", host, "diatype-bold-italic.woff) format('woff'),url(", host, "diatype-bold-italic.otf) format('opentype');font-weight:bold;font-style:italic;font-display:fallback;}@font-face{font-family:", fontDiatype, ";src:url(", host, "diatype-bold.woff2) format('woff2'),url(", host, "diatype-bold.woff) format('woff'),url(", host, "diatype-bold.otf) format('opentype');font-weight:bold;font-style:normal;font-display:fallback;}@font-face{font-family:", fontDiatype, ";src:url(", host, "diatype-medium-italic.woff2) format('woff2'),url(", host, "diatype-medium-italic.woff) format('woff'),url(", host, "diatype-medium-italic.otf) format('opentype');font-weight:500;font-style:italic;font-display:fallback;}@font-face{font-family:", fontDiatype, ";src:url(", host, "diatype-medium.woff2) format('woff2'),url(", host, "diatype-medium.woff) format('woff'),url(", host, "diatype-medium.otf) format('opentype');font-weight:500;font-style:normal;font-display:fallback;}@font-face{font-family:", fontDiatype, ";src:url(", host, "diatype-regular-italic.woff2) format('woff2'),url(", host, "diatype-regular-italic.woff) format('woff'),url(", host, "diatype-regular-italic.otf) format('opentype');font-weight:normal;font-style:italic;font-display:fallback;}@font-face{font-family:", fontDiatype, ";src:url(", host, "diatype-regular.woff2) format('woff2'),url(", host, "diatype-regular.woff) format('woff'),url(", host, "diatype-regular.otf) format('opentype');font-weight:normal;font-style:normal;font-display:fallback;}" + (process.env.NODE_ENV === "production" ? "" : ";label:diatype;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
});

var monoLisa = /*#__PURE__*/fontStylesFactory(function (_ref) {
  var host = _ref.host;
  return /*#__PURE__*/css("@font-face{font-family:", fontMonoLisa, ";src:url(", host, "mono-lisa--light.ttf) format('truetype');font-weight:300;font-style:normal;font-display:fallback;}@font-face{font-family:", fontMonoLisa, ";src:url(", host, "mono-lisa--light-italic.ttf) format('truetype');font-weight:300;font-style:italic;font-display:fallback;}@font-face{font-family:", fontMonoLisa, ";src:url(", host, "mono-lisa--regular.ttf) format('truetype');font-weight:400;font-style:normal;font-display:fallback;}@font-face{font-family:", fontMonoLisa, ";src:url(", host, "mono-lisa--regular-italic.ttf) format('truetype');font-weight:400;font-style:italic;font-display:fallback;}@font-face{font-family:", fontMonoLisa, ";src:url(", host, "mono-lisa--medium.ttf) format('truetype');font-weight:500;font-style:normal;font-display:fallback;}@font-face{font-family:", fontMonoLisa, ";src:url(", host, "mono-lisa--medium-italic.ttf) format('truetype');font-weight:500;font-style:italic;font-display:fallback;}@font-face{font-family:", fontMonoLisa, ";src:url(", host, "mono-lisa--bold.ttf) format('truetype');font-weight:700;font-style:normal;font-display:fallback;}@font-face{font-family:", fontMonoLisa, ";src:url(", host, "mono-lisa--bold-italic.ttf) format('truetype');font-weight:700;font-style:italic;font-display:fallback;}" + (process.env.NODE_ENV === "production" ? "" : ";label:monoLisa;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
});

var _excluded$6 = ["includeNew", "includeLegacy"];
var Fonts = function Fonts(_ref) {
  var _ref$includeNew = _ref.includeNew,
    includeNew = _ref$includeNew === void 0 ? false : _ref$includeNew,
    _ref$includeLegacy = _ref.includeLegacy,
    includeLegacy = _ref$includeLegacy === void 0 ? true : _ref$includeLegacy,
    props = _objectWithoutProperties(_ref, _excluded$6);
  var commonFonts = [monoLisa(props)];
  var newFonts = [diatype(props)];
  var legacyFonts = [adelleSans(props)];
  return jsx(Global, {
    styles: /*#__PURE__*/css([].concat(commonFonts, _toConsumableArray(includeNew ? newFonts : []), _toConsumableArray(includeLegacy ? legacyFonts : [])), process.env.NODE_ENV === "production" ? "" : ";label:Fonts;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkZvbnRzLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUF3QmMiLCJmaWxlIjoiRm9udHMudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgR2xvYmFsLCBjc3MgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuXG5pbXBvcnQgeyBhZGVsbGVTYW5zIH0gZnJvbSAnLi9hZGVsbGVTYW5zJztcbmltcG9ydCB7IGRpYXR5cGUgfSBmcm9tICcuL2RpYXR5cGUnO1xuaW1wb3J0IHsgbW9ub0xpc2EgfSBmcm9tICcuL21vbm9MaXNhJztcbmltcG9ydCB7IEZvbnRQcm9wcyB9IGZyb20gJy4vdHlwZXMnO1xuXG5leHBvcnQgaW50ZXJmYWNlIEZvbnRzUHJvcHMgZXh0ZW5kcyBGb250UHJvcHMge1xuICBpbmNsdWRlTmV3PzogYm9vbGVhbjtcbiAgaW5jbHVkZUxlZ2FjeT86IGJvb2xlYW47XG59XG5cbmNvbnN0IEZvbnRzID0gKHtcbiAgaW5jbHVkZU5ldyA9IGZhbHNlLFxuICBpbmNsdWRlTGVnYWN5ID0gdHJ1ZSxcbiAgLi4ucHJvcHNcbn06IEZvbnRzUHJvcHMpID0+IHtcbiAgY29uc3QgY29tbW9uRm9udHMgPSBbbW9ub0xpc2EocHJvcHMpXTtcbiAgY29uc3QgbmV3Rm9udHMgPSBbZGlhdHlwZShwcm9wcyldO1xuICBjb25zdCBsZWdhY3lGb250cyA9IFthZGVsbGVTYW5zKHByb3BzKV07XG5cbiAgcmV0dXJuIChcbiAgICA8R2xvYmFsXG4gICAgICBzdHlsZXM9e2NzcyhbXG4gICAgICAgIC4uLmNvbW1vbkZvbnRzLFxuICAgICAgICAuLi4oaW5jbHVkZU5ldyA/IG5ld0ZvbnRzIDogW10pLFxuICAgICAgICAuLi4oaW5jbHVkZUxlZ2FjeSA/IGxlZ2FjeUZvbnRzIDogW10pLFxuICAgICAgXSl9XG4gICAgLz5cbiAgKTtcbn07XG5cbmV4cG9ydCB7IEZvbnRzIH07XG4iXX0= */")
  });
};

var bauhausFeatures = ['borders', 'color', 'components', 'fonts', 'typography'];
var nextFeatures = /*#__PURE__*/[].concat(bauhausFeatures, ['sizes', 'space']);
var nextFeatureMap = {
  borders: ['radii'],
  color: ['colors'],
  components: ['components'],
  fonts: ['fonts'],
  sizes: ['sizes'],
  space: ['space'],
  typography: ['fontSizes', 'fontWeights', 'lineHeights', 'letterSpacings', 'textStyles']
};
var applyThemeOverlay = function applyThemeOverlay(theme, overlayTheme, overlayFeatures) {
  if (!overlayFeatures) return theme;

  // We want to do a shallow merge on the components because we don't want to
  // merge the component themes themselves. Any overlaid theme components
  // replace existing component themes entirely.
  var components = overlayFeatures === 'all' || overlayFeatures.includes('components') ? _mergeLeft(overlayTheme.components, theme.components) : theme.components;
  if (overlayFeatures === 'all') {
    return _objectSpread2(_objectSpread2({}, _mergeDeepLeft(overlayTheme, theme)), {}, {
      components: components
    });
  }
  var features = entries(nextFeatureMap).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
      key = _ref2[0];
    return includes(overlayFeatures, key);
  }).flatMap(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      value = _ref4[1];
    return value;
  });
  return _objectSpread2(_objectSpread2({}, _mergeDeepLeft(pick(overlayTheme, features.filter(function (i) {
    return i !== 'components';
  })), theme)), {}, {
    components: components
  });
};
var attachNextThemeRoot = function attachNextThemeRoot(children, className) {
  var root = Children.only(children);
  return /*#__PURE__*/cloneElement(root, _objectSpread2({
    className: root.props.className && typeof root.props.className === 'string' ? "".concat(className, " ").concat(root.props.className) : className
  }, root.props));
};

var _excluded$5 = ["attach", "children", "next"];
var _createContext$1 = /*#__PURE__*/createContext({
    name: 'NextFeaturesContext',
    strict: false
  }),
  _createContext2$1 = /*#__PURE__*/_slicedToArray(_createContext$1, 2),
  NextFeaturesProvider = _createContext2$1[0],
  useNextFeaturesContext = _createContext2$1[1];
var useIsNextFeatureEnabled = function useIsNextFeatureEnabled(feature) {
  var next = useNextFeaturesContext();
  if (!next) return false;
  if (next === 'all') return true;
  return next.includes(feature);
};

/**
 * Apply a modified theme to a component subtree nested in an existing theme
 * with the specified `features` enabled. This attaches CSS variables that
 * override the outer theme's CSS variables, and includes fonts when they are
 * marked as enabled in `features`.
 */
var NestedThemeProvider = function NestedThemeProvider(_ref) {
  var selector = _ref.selector,
    children = _ref.children,
    _ref$features = _ref.features,
    features = _ref$features === void 0 ? 'all' : _ref$features,
    _ref$includeFonts = _ref.includeFonts,
    includeFonts = _ref$includeFonts === void 0 ? true : _ref$includeFonts,
    _ref$includeCssVars = _ref.includeCssVars,
    includeCssVars = _ref$includeCssVars === void 0 ? true : _ref$includeCssVars,
    fontsHost = _ref.fontsHost,
    theme = _ref.theme;
  var computedTheme = useMemo(function () {
    return toCSSVar(theme);
  }, [theme]);
  return jsxs(ThemeProvider, {
    theme: computedTheme,
    children: [includeCssVars && selector && jsx(CSSVars, {
      root: selector
    }), includeFonts && jsx(Fonts, {
      host: fontsHost,
      includeLegacy: false,
      includeNew: includeFonts && (features === 'all' || features.includes('fonts'))
    }), jsx(NextFeaturesProvider, {
      value: features,
      children: children
    })]
  });
};
var _createContext3 = /*#__PURE__*/createContext({
    name: 'NextThemeRootContext',
    strict: false
  }),
  _createContext4 = /*#__PURE__*/_slicedToArray(_createContext3, 2),
  NextThemeRootProvider = _createContext4[0],
  useNextThemeRoot = _createContext4[1];

/**
 * Get the CSS class name that next theme CSS variables will be attached to
 */
var useNextThemeRootClassName = function useNextThemeRootClassName() {
  var _context$className;
  var context = useNextThemeRoot();
  return (_context$className = context === null || context === void 0 ? void 0 : context.className) !== null && _context$className !== void 0 ? _context$className : '';
};
var NextProvider = function NextProvider(_ref2) {
  var _ref2$attach = _ref2.attach,
    attach = _ref2$attach === void 0 ? false : _ref2$attach,
    childrenProp = _ref2.children,
    _ref2$next = _ref2.next,
    next = _ref2$next === void 0 ? 'all' : _ref2$next,
    props = _objectWithoutProperties(_ref2, _excluded$5);
  var className = useUniqueSelector('next-provider-root');
  var selector = ".".concat(className);
  var children = attach ? attachNextThemeRoot(childrenProp, className) : childrenProp;
  var outerTheme = useTheme$1();
  var innerTheme = applyThemeOverlay(outerTheme, theme, next);
  return jsx(NextThemeRootProvider, {
    value: {
      className: className
    },
    children: jsx(NestedThemeProvider, _objectSpread2(_objectSpread2({}, props), {}, {
      features: next,
      selector: selector,
      theme: innerTheme,
      children: children
    }))
  });
};

var _excluded$4 = ["sx", "gap", "spacing"];
var _createContext = /*#__PURE__*/createContext({
    name: 'PaintToastContext'
  }),
  _createContext2 = /*#__PURE__*/_slicedToArray(_createContext, 2),
  Provider$1 = _createContext2[0],
  useContext = _createContext2[1];
var useToastTargetRefs = function useToastTargetRefs() {
  var toastPortalRef = useRef(null);
  var toastTargetRef = function toastTargetRef(element) {
    if (typeof window === 'undefined') return;
    toastPortalRef.current = element !== null && element !== void 0 ? element : document.body;
  };
  useSafeLayoutEffect(function () {
    if (toastPortalRef.current === null) {
      toastPortalRef.current = document.body;
    }
  }, []);
  return {
    toastPortalRef: toastPortalRef,
    toastTargetRef: toastTargetRef
  };
};
var ToastTarget = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var sx = _ref.sx,
    gap = _ref.gap,
    spacing = _ref.spacing,
    props = _objectWithoutProperties(_ref, _excluded$4);
  var _useContext = useContext(),
    targetRef = _useContext.containerRef;
  var toast = useToast();
  useEffect(function () {
    var reset = function reset() {
      toast.closeAll();
      toast({
        duration: 0,
        render: function render() {
          return null;
        }
      });
    };
    reset();
    return reset;
  }, [toast]);
  return jsx(chakra.div, _objectSpread2(_objectSpread2({
    position: "relative",
    sx: _objectSpread2(_objectSpread2({}, sx), {}, {
      '& ul[id^="chakra-toast-manager-"]': {
        padding: '0 !important',
        position: 'absolute !important',
        gap: gap !== null && gap !== void 0 ? gap : spacing
      },
      '& #chakra-toast-manager-top': {
        top: '0 !important',
        left: '0 !important',
        right: '0 !important'
      },
      '& #chakra-toast-manager-bottom': {
        bottom: '0 !important',
        right: '0 !important',
        left: '0 !important'
      },
      '& #chakra-toast-manager-top-left': {
        top: '0 !important',
        left: '0 !important'
      },
      '& #chakra-toast-manager-top-right': {
        top: '0 !important',
        right: '0 !important'
      },
      '& #chakra-toast-manager-bottom-left': {
        bottom: '0 !important',
        left: '0 !important'
      },
      '& #chakra-toast-manager-bottom-right': {
        bottom: '0 !important',
        right: '0 !important'
      }
    })
  }, props), {}, {
    ref: useMergeRefs(ref, targetRef)
  }));
});

var _excluded$3 = ["customTheme", "extraComponentThemes", "next"];
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref = process.env.NODE_ENV === "production" ? {
  name: "43kghl",
  styles: "ul[id^=\"chakra-toast-manager-\"]{padding:0 !important;margin:0 !important;}"
} : {
  name: "1fhffyq-RootProvider",
  styles: "ul[id^=\"chakra-toast-manager-\"]{padding:0 !important;margin:0 !important;};label:RootProvider;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var RootProvider = function RootProvider(_ref2) {
  var children = _ref2.children,
    environment = _ref2.environment,
    features = _ref2.features,
    fontsHost = _ref2.fontsHost,
    _ref2$includeFonts = _ref2.includeFonts,
    includeFonts = _ref2$includeFonts === void 0 ? false : _ref2$includeFonts,
    portalZIndex = _ref2.portalZIndex,
    _ref2$resetCSS = _ref2.resetCSS,
    resetCSS = _ref2$resetCSS === void 0 ? false : _ref2$resetCSS,
    theme = _ref2.theme;
  var _useToastTargetRefs = useToastTargetRefs(),
    toastPortalRef = _useToastTargetRefs.toastPortalRef,
    toastTargetRef = _useToastTargetRefs.toastTargetRef;
  return jsxs(ChakraProvider, {
    cssVarsRoot: "body",
    environment: environment,
    portalZIndex: portalZIndex,
    resetCSS: resetCSS,
    theme: theme,
    toastOptions: {
      portalProps: {
        containerRef: toastPortalRef
      }
    },
    children: [jsx(Global, {
      styles: _ref
    }), jsxs(Provider$1, {
      value: {
        containerRef: toastTargetRef
      },
      children: [includeFonts && jsx(Fonts, {
        host: fontsHost,
        includeLegacy: includeFonts === 'all' || !features || features !== 'all' && !features.includes('fonts'),
        includeNew: includeFonts === 'all' || features === 'all' || (features === null || features === void 0 ? void 0 : features.includes('fonts'))
      }), features ? jsx(NextFeaturesProvider, {
        value: features,
        children: children
      }) : children]
    })]
  });
};
var Provider = function Provider(_ref3) {
  var customTheme = _ref3.customTheme,
    extraComponentThemes = _ref3.extraComponentThemes,
    next = _ref3.next,
    props = _objectWithoutProperties(_ref3, _excluded$3);
  var theme$2 = customTheme !== null && customTheme !== void 0 ? customTheme : theme$1;
  var components = extraComponentThemes;
  var themeWithComponents = components ? extendTheme({
    components: components
  }, theme$2) : theme$2;
  return jsx(RootProvider, _objectSpread2(_objectSpread2({}, props), {}, {
    features: next,
    theme: applyThemeOverlay(themeWithComponents, theme, next)
  }));
};

var _excluded$2 = ["children", "features", "themeOverrides", "includeFonts"];
var revertedFeatures = ['space', 'sizes'];
var Context = /*#__PURE__*/createContext$1(false);
var ToastContainerStyles = function ToastContainerStyles() {
  var _useTheme = useTheme$1(),
    space = _useTheme.space;
  return jsx(Global, {
    styles: /*#__PURE__*/css({
      'ul[id^="chakra-toast-manager-"]': {
        padding: "".concat(space[500], " !important"),
        margin: '0 !important',
        gap: space[400],
        '[role="status"]': {
          margin: 0
        }
      }
    }, process.env.NODE_ENV === "production" ? "" : ";label:ToastContainerStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  });
};
var DesignSystemProvider = function DesignSystemProvider(_ref) {
  var children = _ref.children,
    _ref$features = _ref.features,
    features = _ref$features === void 0 ? 'all' : _ref$features,
    _ref$themeOverrides = _ref.themeOverrides,
    themeOverrides = _ref$themeOverrides === void 0 ? {} : _ref$themeOverrides,
    _ref$includeFonts = _ref.includeFonts,
    includeFonts = _ref$includeFonts === void 0 ? true : _ref$includeFonts,
    props = _objectWithoutProperties(_ref, _excluded$2);
  var existingTheme = useTheme$1();
  var className = useUniqueSelector('nested-design-system-provider-root');
  var selector = ".".concat(className);
  var next = (features === 'all' ? nextFeatures : features).filter(function (feature) {
    return !includes(revertedFeatures, feature);
  });
  var theme$3 = extendTheme(themeOverrides, applyThemeOverlay(applyThemeOverlay(theme$1, theme, next), theme$2, features));
  var parentFeatures = useNextFeaturesContext();
  var isNested = useContext$1(Context);
  var isNestedSubset = isNested && (parentFeatures === 'all' || next.every(function (feature) {
    return parentFeatures === null || parentFeatures === void 0 ? void 0 : parentFeatures.includes(feature);
  }));
  if (isNestedSubset) {
    process.env.NODE_ENV !== "production" ? warning(false, 'DesignSystemProvider: this provider is nested in another `DesignSystemProvider`, so this is a no-op. You should remove this nested `DesignSystemProvider`.') : void 0;
    return children;
  }

  // We're using the Emotion theme context to detect any nesting
  // and the default value for that context is an empty object
  if (Object.keys(existingTheme).length > 0) {
    var isDefined = !!children;
    var isObject = _typeof(children) === 'object';
    var isFragment = isDefined && isObject && 'type' in children && children.type === Fragment;

    // Do our best to throw an error if we can't attach CSS variables for the
    // nested theme. The direct descendent of `DesignSystemProvider` has to be a
    // DOM element that we can attach the CSS variable scope to.
    !(isDefined && isObject && !isFragment && 'props' in children && _typeof(children.props) === 'object') ? process.env.NODE_ENV !== "production" ? invariant(false, "BauhausProvider: unable to attach CSS variables to provided children: \n".concat(String(children))) : invariant(false) : void 0;
    return jsx(Context.Provider, {
      value: true,
      children: jsx(NextThemeRootProvider, {
        value: {
          className: className
        },
        children: jsxs(NestedThemeProvider, _objectSpread2(_objectSpread2({
          features: features,
          includeFonts: includeFonts !== false,
          selector: selector,
          theme: theme$3
        }, props), {}, {
          children: [jsx(ToastContainerStyles, {}), attachNextThemeRoot(children, className)]
        }))
      })
    });
  }
  return jsx(Context.Provider, {
    value: true,
    children: jsxs(RootProvider, _objectSpread2(_objectSpread2({
      features: features,
      includeFonts: includeFonts,
      theme: theme$3
    }, props), {}, {
      children: [jsx(ToastContainerStyles, {}), children]
    }))
  });
};

var useTheme = function useTheme() {
  return useTheme$1();
};

/**
 * @deprecated use `useBauhausTheme`
 */
var useNextTheme = function useNextTheme() {
  var next = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'all';
  var theme$1 = useTheme$1();
  return useMemo(function () {
    return toCSSVar(applyThemeOverlay(theme$1, theme, next));
  }, [next, theme$1]);
};

/**
 * Special hook for edge cases where components rendered in a `Portal`, etc.
 * don't get the theme properly from a provider
 *
 * @param features theme features to enable
 */
var useBauhausTheme = function useBauhausTheme() {
  var features = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'all';
  var theme$1 = useTheme$1();
  var next = (features === 'all' ? nextFeatures : features).filter(function (feature) {
    return !includes(revertedFeatures, feature);
  });
  return useMemo(function () {
    return toCSSVar(applyThemeOverlay(applyThemeOverlay(theme$1, theme, next), theme$2, features));
  }, [features, next, theme$1]);
};

var _excluded$1 = ["children", "isDisplay", "isLight", "size", "noMargin", "withCapsize", "mb", "marginBottom"];
var elements = {
  100: 'h6',
  200: 'h6',
  300: 'h5',
  400: 'h4',
  500: 'h3',
  600: 'h2',
  650: 'h2',
  700: 'h1',
  800: 'h1',
  900: 'h1'
};
var aliasNames = /*#__PURE__*/Object.keys(headingAliases);
var getAlias = function getAlias(alias) {
  return typeof alias === 'string' && includes(aliasNames, alias) ? headingAliases[alias] : alias;
};
var Heading = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    _ref$isDisplay = _ref.isDisplay,
    isDisplay = _ref$isDisplay === void 0 ? false : _ref$isDisplay,
    _ref$isLight = _ref.isLight,
    isLight = _ref$isLight === void 0 ? false : _ref$isLight,
    _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? 600 : _ref$size,
    _ref$noMargin = _ref.noMargin,
    noMargin = _ref$noMargin === void 0 ? false : _ref$noMargin,
    _ref$withCapsize = _ref.withCapsize,
    withCapsize = _ref$withCapsize === void 0 ? false : _ref$withCapsize,
    mb = _ref.mb,
    marginBottom = _ref.marginBottom,
    props = _objectWithoutProperties(_ref, _excluded$1);
  var size = mapResponsive(function (s) {
    return "".concat(getAlias(s));
  }, sizeProp);
  var largestSize = reduceResponsive(function (acc, value) {
    if (!value) return acc;
    var s = getAlias(value);
    return s > acc ? s : acc;
  }, 200, sizeProp);
  var textStyle = withCapsize ? mapResponsive(function (s) {
    return "heading".concat(getAlias(s), "WithCapsizeAndMargin");
  }, sizeProp) : undefined;
  var getVariant = function getVariant() {
    if (isDisplay) return 'display';
    if (isLight) return 'light';
    return 'default';
  };
  return jsx(Heading$1, _objectSpread2(_objectSpread2({
    as: elements[largestSize],
    marginTop: "0",
    textStyle: textStyle
  }, withTestId(props)), {}, {
    marginBottom: noMargin ? '0 !important' : marginBottom !== null && marginBottom !== void 0 ? marginBottom : mb,
    ref: ref,
    size: size,
    variant: getVariant(),
    children: children
  }));
});
Heading.displayName = 'Heading';

var _excluded = ["brickDelay", "brickDelayVariation", "brickProps", "captionDuration", "captions", "color", "columns", "label", "rows", "brickSpacing", "speed"];
var _templateObject, _templateObject2;
var MotionHeading = /*#__PURE__*/motion(Heading);
var BRICK_OFFSET = '-200px';
var spin = /*#__PURE__*/keyframes(_templateObject || (_templateObject = /*#__PURE__*/_taggedTemplateLiteral(["\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(720deg); }\n"])));
var Loader = function Loader(props) {
  return jsxs(chakra.svg, _objectSpread2(_objectSpread2({
    fill: "none",
    viewBox: "0 0 288 288",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [jsx("path", {
      d: "M144 2.99999C144 1.34314 145.344 -0.00327085 147 0.0312428C168.693 0.483233 190.018 5.83256 209.375 15.6951C229.622 26.0118 247.141 40.9742 260.498 59.3589C273.856 77.7436 282.672 99.0285 286.227 121.473C289.625 142.93 288.123 164.864 281.849 185.636C281.37 187.222 279.675 188.083 278.099 187.571L270.11 184.976C268.534 184.464 267.676 182.772 268.151 181.185C273.725 162.576 275.047 142.938 272.004 123.726C268.805 103.526 260.87 84.3692 248.849 67.823C236.827 51.2768 221.06 37.8107 202.837 28.5256C185.506 19.6948 166.421 14.8843 147 14.4347C145.344 14.3964 144 13.0569 144 11.4L144 2.99999Z",
      fill: "currentColor"
    }), jsx("path", {
      d: "M288 144C288 223.529 223.529 288 144 288C64.471 288 0 223.529 0 144C0 64.471 64.471 0 144 0C223.529 0 288 64.471 288 144ZM14.4 144C14.4 215.576 72.4239 273.6 144 273.6C215.576 273.6 273.6 215.576 273.6 144C273.6 72.4239 215.576 14.4 144 14.4C72.4239 14.4 14.4 72.4239 14.4 144Z",
      fill: "currentColor",
      opacity: "0.4"
    })]
  }));
};
var animateBrick = function animateBrick() {
  return keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  0% { transform: translateY(", ") rotateZ(", "deg); }\n  100% { transform: translateY(0px) rotateZ(0deg);  }\n"])), BRICK_OFFSET, random(90, 0));
};
var ProgressiveLoader = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$brickDelay = _ref.brickDelay,
    brickDelay = _ref$brickDelay === void 0 ? 0.25 : _ref$brickDelay,
    _ref$brickDelayVariat = _ref.brickDelayVariation,
    brickDelayVariation = _ref$brickDelayVariat === void 0 ? 3 : _ref$brickDelayVariat,
    brickProps = _ref.brickProps,
    _ref$captionDuration = _ref.captionDuration,
    captionDuration = _ref$captionDuration === void 0 ? 2000 : _ref$captionDuration,
    captions = _ref.captions,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'primary.600' : _ref$color,
    _ref$columns = _ref.columns,
    columnsProp = _ref$columns === void 0 ? 3 : _ref$columns,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Loading' : _ref$label,
    _ref$rows = _ref.rows,
    rowsProp = _ref$rows === void 0 ? 6 : _ref$rows,
    _ref$brickSpacing = _ref.brickSpacing,
    spacing = _ref$brickSpacing === void 0 ? '2px' : _ref$brickSpacing,
    _ref$speed = _ref.speed,
    speed = _ref$speed === void 0 ? 500 : _ref$speed,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useTheme = useTheme(),
    lineHeights = _useTheme.lineHeights;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    captionIndex = _useState2[0],
    setCaptionIndex = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isAnimating = _useState4[0],
    setIsAnimating = _useState4[1];
  useInterval(function () {
    if (!captions) return;
    setCaptionIndex(function (i) {
      return i + 1 > captions.length - 1 ? 0 : i + 1;
    });
  }, captionDuration);
  var bricks = useMemo(function () {
    return Array.from({
      length: rowsProp
    }).map(function (_, row) {
      return {
        row: row,
        columns: Array.from({
          length: row === 0 ? columnsProp - 1 : columnsProp
        }, function (__, column) {
          var total = rowsProp * columnsProp - 1;
          var index = row === 0 ? column : row * columnsProp - 1 + column;
          var delay = (total - index) * brickDelay + random(brickDelay * brickDelayVariation, 0, false);
          return {
            column: column,
            index: index,
            animation: "0.5s ease-in ".concat(delay, "s 1 normal both running ").concat(animateBrick())
          };
        })
      };
    });
  }, [brickDelay, brickDelayVariation, columnsProp, rowsProp]);
  useEffect(function () {
    return setIsAnimating(true);
  }, []);
  return jsxs(VStack, _objectSpread2(_objectSpread2({
    "aria-busy": true,
    "aria-label": label,
    "aria-live": "polite",
    color: color,
    ref: ref,
    spacing: "500"
  }, props), {}, {
    children: [jsxs(Box, {
      alignContent: "center",
      justifyContent: "center",
      overflow: "hidden",
      position: "relative",
      role: "progressbar",
      width: {
        base: '600',
        width250: '700'
      },
      children: [jsx(Box, {
        animation: "".concat(durations[speed] * 3, "s linear 0s infinite normal none running ").concat(spin),
        height: "100%",
        width: "100%",
        children: jsx(Loader, {
          animation: "".concat(durations[speed], "s ease-in-out 0s infinite normal none running ").concat(spin),
          width: "100%"
        })
      }), jsx(VStack, {
        clipPath: "circle(calc(50% - 12px) at 50% 50%)",
        flexDirection: "column",
        height: "100%",
        justifyContent: "center",
        overflow: "hidden",
        padding: "27.5%",
        position: "absolute",
        spacing: spacing,
        width: "100%",
        children: bricks.map(function (_ref2) {
          var row = _ref2.row,
            columns = _ref2.columns;
          var r = "row-".concat(row);
          return jsx(HStack, {
            className: r,
            height: "".concat(100 / rowsProp, "%"),
            spacing: spacing,
            transform: "translateX(".concat(row % 2 === 0 ? '7' : '-3', "%)"),
            width: "100%",
            children: columns.map(function (_ref3) {
              var column = _ref3.column,
                animation = _ref3.animation;
              var c = "column-".concat(column);
              return jsx(chakra.div, _objectSpread2({
                animation: isAnimating ? animation : 'none',
                bg: "currentColor",
                borderColor: "currentColor",
                borderRadius: {
                  base: '2px',
                  width250: '200'
                },
                className: "brick ".concat(c),
                flexShrink: 0,
                height: "100%",
                position: "relative",
                transform: "translateY(".concat(BRICK_OFFSET, ")"),
                width: "".concat(100 / columnsProp, "%")
              }, brickProps), c);
            })
          }, r);
        })
      })]
    }), captions && jsx(Center, {
      height: lineHeights[600],
      position: "relative",
      width: "100%",
      children: jsx(AnimatePresence, {
        children: jsx(MotionHeading, {
          animate: {
            opacity: 1,
            y: '0%'
          },
          color: "neutral.700",
          exit: {
            opacity: 0,
            y: '-50%'
          },
          initial: {
            opacity: 0,
            y: '50%'
          },
          position: "absolute",
          size: {
            base: 300,
            width250: 500
          },
          textAlign: "center",
          transition: {
            y: motion$2.framer.firm,
            opacity: {
              duration: 0.1,
              bounce: 0
            }
          },
          width: "100%",
          children: captions[captionIndex]
        }, captionIndex)
      })
    })]
  }));
});

export { Box as B, DesignSystemProvider as D, Fonts as F, Heading as H, Loader$1 as L, NextProvider as N, ProgressiveLoader as P, Stack as S, ToastTarget as T, _objectWithoutProperties as _, _objectSpread2 as a, _taggedTemplateLiteral as b, _defineProperty as c, _slicedToArray as d, useIsNextFeatureEnabled as e, applyTestId as f, dataAttribute as g, _toConsumableArray as h, useNextTheme as i, useUniqueSelector as j, Provider as k, useNextThemeRootClassName as l, motion as m, bauhausFeatures as n, nextFeatures as o, useBauhausTheme as p, NestedThemeProvider as q, useTheme as u, withTestId as w };
